import { ActionArgs } from 'xstate5';

import { Context } from './context';
import { Event } from './events';

// ─────────────────────────────────────────────────────────────────────────────

export type ScrollspyAction<ActionParams extends Record<string, unknown> | void = void> = (
  actionArgs: ActionArgs<Context, Event, Event>,
  params: ActionParams,
) => void;
